import {Action} from '@ngrx/store';
import {type} from '../utilities/type';
import {ContractLinkSummaries} from '../models/contract-link';

export const subscriptionsLinkContractActionTypes = {
  LOAD: type('[Subscriptions Link Contract] Load'),
  LOAD_SUCCESS: type('[Subscriptions Link Contract] Load Success'),
  LOAD_FAIL: type('[Subscriptions Link Contract] Load Fail')
};

export class LoadSubscriptionsLinkContractAction implements Action {
  readonly type = subscriptionsLinkContractActionTypes.LOAD;
  constructor(public payload?: Object) {}
}

export class LoadSubscriptionsLinkContractSuccessAction implements Action {
  readonly type = subscriptionsLinkContractActionTypes.LOAD_SUCCESS;
  constructor(public payload?:  ContractLinkSummaries[]) {}
}

export class LoadSubscriptionsLinkContractFailAction implements Action {
  readonly type = subscriptionsLinkContractActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
